export const videoKeys = {
    all: ['videos'],
    list: (params) => ['videos', 'list', params],
};
